












































































import { mixins } from 'vue-class-component'
import { Component, Prop } from 'vue-property-decorator'
import AppTextSearch from '@/components/AppTextSearch.vue'
import AppTextField from '@/components/AppTextField.vue'
import AppPhoneInput from '@/components/AppPhoneInput.vue'
import AppSelector from '@/components/AppSelector.vue'
import SearchContact from '@/mixins/search-queries/search-contact'
import { IAccountContactInput } from '@/modules/Account/interfaces/account-form'
import { Contact } from '@/modules/Contact/interfaces/contact'
import { states } from '@/utils/us_states'
import ContactDialog from '@/modules/Contact/scripts/contact-dialog'

@Component({
  components: {
    AppTextSearch,
    AppTextField,
    AppSelector,
    AppPhoneInput
  }
})
export default class AccountFormContact extends mixins(SearchContact, SearchContact, ContactDialog) {
  @Prop({ type: Object as () => IAccountContactInput }) value!: IAccountContactInput
  @Prop({ type: Object as () => Contact }) readonly contact!: Contact

  states = states

  get disable () {
    return !!this.contact
  }

  copyMailingAddressToBilling () {
    this.value.billingAddressStreet = this.value.mailingAddressStreet
    this.value.billingAddressCity = this.value.mailingAddressCity
    this.value.billingAddressStateIdx = this.value.mailingAddressStateIdx
    this.value.billingAddressCountry = this.value.mailingAddressCountry
    this.value.billingAddressPostalCode = this.value.mailingAddressPostalCode
  }

  validate () {
    return (this.$refs.form as Vue & { validate: () => boolean }).validate()
  }

  onContactCreateSuccess (contact: Contact) {
    this.hideContactEditDialog()
    this.value.primaryContact = {
      id: +contact.id,
      name: contact.name
    }
  }
}
